// extracted by mini-css-extract-plugin
module.exports = {"lecture_container":"lecturePlayer_lecture_container__BTAYt","iframe_wrapper":"lecturePlayer_iframe_wrapper__2rE7K","shield":"lecturePlayer_shield__DU73t"};